/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_No_PresetsInputs */

const en_batch_subtitle_export_no_presets = /** @type {(inputs: Batch_Subtitle_Export_No_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No subtitle export presets found. Create presets in Subtitle Export modal.`)
};

const fr_batch_subtitle_export_no_presets = /** @type {(inputs: Batch_Subtitle_Export_No_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun préréglage d’export de sous-titres trouvé. Créez des préréglages dans la fenêtre Exportation des sous-titres.`)
};

const de_batch_subtitle_export_no_presets = /** @type {(inputs: Batch_Subtitle_Export_No_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden keine Untertitel-Exportvoreinstellungen gefunden. Erstellen Sie Voreinstellungen im Untertitel-Export-Dialogfeld.`)
};

const it_batch_subtitle_export_no_presets = /** @type {(inputs: Batch_Subtitle_Export_No_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun preset di esportazione dei sottotitoli trovato. Crea preset nella modalità Esportazione sottotitoli.`)
};

const ru_batch_subtitle_export_no_presets = /** @type {(inputs: Batch_Subtitle_Export_No_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительно настроенные параметры экспорта субтитров не найдены. Создайте параметры в модальном окне экспорта субтитров.`)
};

const es_batch_subtitle_export_no_presets = /** @type {(inputs: Batch_Subtitle_Export_No_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron ajustes preestablecidos para la exportación de subtítulos. Cree ajustes preestablecidos en la ventana "Exportar subtítulos".`)
};

const zh_cn2_batch_subtitle_export_no_presets = /** @type {(inputs: Batch_Subtitle_Export_No_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到字幕导出预设。请在字幕导出对话框中创建预设。`)
};

const ja_batch_subtitle_export_no_presets = /** @type {(inputs: Batch_Subtitle_Export_No_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕エクスポートプリセットが見つかりません。字幕エクスポートモーダルでプリセットを作成してください。`)
};

const hi_batch_subtitle_export_no_presets = /** @type {(inputs: Batch_Subtitle_Export_No_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सबटाइटल एक्सपोर्ट के लिए कोई प्रीसेट नहीं मिला। सबटाइटल एक्सपोर्ट मॉडल में प्रीसेट बनाएं।`)
};

const pt_pt2_batch_subtitle_export_no_presets = /** @type {(inputs: Batch_Subtitle_Export_No_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foram encontradas predefinições de exportação de legendas. Crie predefinições na janela modal de Exportação de Legendas.`)
};

/**
* | output |
* | --- |
* | "No subtitle export presets found. Create presets in Subtitle Export modal." |
*
* @param {Batch_Subtitle_Export_No_PresetsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_no_presets = /** @type {((inputs?: Batch_Subtitle_Export_No_PresetsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_No_PresetsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_no_presets(inputs)
	if (locale === "de") return de_batch_subtitle_export_no_presets(inputs)
	if (locale === "it") return it_batch_subtitle_export_no_presets(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_no_presets(inputs)
	if (locale === "es") return es_batch_subtitle_export_no_presets(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_no_presets(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_no_presets(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_no_presets(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_no_presets(inputs)
	return en_batch_subtitle_export_no_presets(inputs)
});